import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { computed, ref, PropType, Ref, watch, nextTick } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { tracelessEvseOtas } from '@/api/evses'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import useFormRules from '@/hooks/useFormRules'
export type OperationType = 'create' | 'edit'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseTracelessOta',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  evseid: {
    type: String,
    required: true,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { country } = useProtocolEnums()
const { t } = useI18n()





const createRawFormData = () => ({})

const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())
const { createLetterStartRule } = useFormRules()
const rules = {
  name: [...createLetterStartRule()],
}

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const submit = async () => {
  try {
    await formCom.value.validate()
    isSubmitting.value = true
    formData.value.evseId = props.evseid
    await tracelessEvseOtas(formData.value)

    ElMessage.success(t(`Base.opSuccess`))
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "40%",
    class: "upsert-dialog",
    title: _ctx.$t('Evses.addEvseOTA'),
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formCom",
        ref: formCom,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.address'),
                    prop: "url",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.url,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.url) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})